import { useEffect, useState } from 'react';
import { toast } from 'react-toastify';

import { useModal } from 'context/ModalContext';
import { actionLog } from 'services/actionlog.service';

import { ConfirmacaoDaAcao } from './moldura-da-acao';

interface Props {
  callback: (obj: { id: string; message?: string }) => void;
  id: string;
  status: string | undefined;
  data?: any;
  validateTeamMember: string | undefined | null;
  playerInfo?: any;
}

export default function ModalTeamMemberAccept({ callback, id, data, validateTeamMember, playerInfo }: Props) {
  const modalID = 'validation-team-member-accept';

  const { openModal, closeModal } = useModal();

  const [modalIsOpen, setIsOpen] = useState<boolean>(false);
  const [sending, setSending] = useState<boolean>(false);

  async function registerLog() {
    if (sending) return false;

    setSending(true);

    try {
      await actionLog('me', 'task_team_member_approval', {
        taskId: id,
        targetId: validateTeamMember,
        approved: true,
        original_manager: playerInfo?.chave,
      });

      setSending(false);
      callback({ id: 'reload_task' });
      closeModal();

      toast.success(`Análise realizada com sucesso.`, {
        position: 'top-right',
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    } catch (error) {
      toast.error(`Ocorreu um erro ao registrar sua ação. Por favor, tente novamente em alguns minutos.`, {
        position: 'top-right',
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });

      setSending(false);
    }
  }

  useEffect(() => {
    if (typeof id === 'string' && typeof openModal === 'string' && openModal === `${modalID}-${id}`) {
      setIsOpen(true);
    } else {
      setIsOpen(false);
    }
  }, [id, openModal]);

  if (!modalIsOpen) return <></>;

  return (
    <ConfirmacaoDaAcao
      title="Deseja mesmo aceitar a indicação?"
      onClose={() => (!sending ? closeModal() : null)}
      backDisabled={sending}
      onConfirm={() => {
        registerLog();
      }}
      confirmDisabled={sending}
    >
      <p className="m-0">
        Ao confirmar, o funcionário permanecerá na lista de participantes da realização. Após concluí-la, essa ação não poderá ser
        desfeita.
      </p>
    </ConfirmacaoDaAcao>
  );
}
